module.exports = __webpack_public_path__ + "images/柏纳s长图_05.jpg?v=82d4397a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_05.jpg
 ** module id = 163
 ** module chunks = 1 2
 **/